/**
 * Language resource for validation messages.
 * @typedef {Object} ValidationMessages
 * @property {string} question - Validation message for the question field when it's empty.
 * @property {string} validQuestion - Validation message for the question field when it's not valid.
 * @property {string} typeOfFaqs - Validation message for the type of FAQs field when it's empty.
 * @property {string} answer - Validation message for the answer field when it's empty.
 * @property {string} minPhone - Validation message for the phone number field when it's less than the minimum length.
 * @property {string} phoneNumber - Validation message for the phone number field when it's empty.
 * @property {string} addressReq - Validation message for the address field when it's empty.
 * @property {string} emailReq - Validation message for the email field when it's empty.
 * @property {string} termsAndConditions - Validation message for the terms and conditions field when it's empty.
 * @property {string} privacyPolicy - Validation message for the privacy policy field when it's empty.
 */

/**
 * Language resource for validation messages.
 * @type {ValidationMessages}
 */

export const validation = {
};
